global.RBPlay = (function ($) {

	function init() {
		var videoBlockIframeContainer = $('.js-video-iframe');

        $('.js-filter-year-dropdown').on('change', function () {
            var year = $(this).find('option:selected').val();
            window.location = createFilterUrl(window.location.href, 'year', year);
		});

        $('.js-filter-category-dropdown').on('change', function () {
            var category = $(this).find('option:selected').val();
            window.location = createFilterUrl(window.location.href, 'category', category);
		});

		$('.js-category-tag').click(function () {
			console.log('click', $(this).data('val'));
			$('.js-filter-category-dropdown').val($(this).data('val'));
			$('.js-filter-category-dropdown').change();
		});

		videoBlockIframeContainer.on('click', function () {
			var video = $(this);
			video.addClass('play');

			setTimeout(function () {
				var dataSrc = video.find('iframe').attr('src');
				dataSrc = dataSrc.split('?')[0];
				var dataSrcWithAutoplay = dataSrc + '?auto_play=true';

				video.find('iframe').attr('src', dataSrcWithAutoplay);
			}, 400);
		});
    }

    function createFilterUrl(url, paramName, paramValue) {
        var filterUrl = replaceUrlParam(url, paramName, paramValue);
		// Reset pagination
        filterUrl = replaceUrlParam(filterUrl, 'page', '1');
        // Add anchor link and make sure it's at the end
        filterUrl = filterUrl.replace('#videos', '');
        filterUrl += '#videos';
        return filterUrl;
	}

    function replaceUrlParam(url, paramName, paramValue) {
        if (paramValue === null) {
            paramValue = '';
        }
        var pattern = new RegExp('\\b(' + paramName + '=).*?(&|$)');
        if (url.search(pattern) >= 0) {
            url = url.replace(pattern, '$1' + paramValue + '$2');
        } else {
            url += (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
        }
        return url;
    }

    return {
        init: init
    };
})(jQuery);
